export default {
  baseUrl: process.env.REACT_BACKEND_APP_API_URL,
  // feBaseUrl: process.env.REACT_APP_BASE_URL,
  // clientId: process.env.REACT_APP_FE_CLIENT_ID,
  imageUploadFolder: process.env.REACT_APP_PUBLIC_UPLOAD_IMAGE_FOLDER,
  pdfUploadFolder: process.env.REACT_APP_PUBLIC_UPLOAD_PDF_FOLDER,
};
